// extracted by css-extract-rspack-plugin
export default {"completeButton":"completeButton-M3o7B2"};